import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import PropTypes from 'prop-types';
import useLink from 'Hooks/useLink';
import HouseholdSectionService from 'Components/Flyouts/HouseholdInfo/Sections/Service/HouseholdSectionServicePicker/HouseholdSectionService/HouseholdSectionService';


const HouseholdSectionServiceContainer = ({
  relationshipLink,
}) => {
  const {
    isInitializing, loadingError, collection,
  } = useLink(relationshipLink);

  return (
    <DataContainer
      component={HouseholdSectionService}
      loading={isInitializing}
      loadingError={loadingError}
      componentProps={{
        collection,
      }}
    />
  );
};

HouseholdSectionServiceContainer.propTypes = {
  relationshipLink: PropTypes.object.isRequired,
};

export default HouseholdSectionServiceContainer;
